const data = {
  metadata: {
    title: "Go Further With Faith - Catholic Schools Archdiocese of Boston",
    description:
      "We believe that a Catholic school education best prepares students to be productive, engaged citizens. Use our school finder to learn more about Catholic Schools in the Boston, MA area.",
    keywords:
      "Roman Catholic school, Faith-based education, Massachusetts, elementary school, parochial school, private school, Boston Arlington, Brockton, Cambridge, Everett, Hingham, Kingston, Lawrence, Lowell, Lynn, Malden, Methuen, Milton, Newton, Peabody, Reading, West Roxbury",
  },
  header: {
    "header-colors": [
      {
        color: "blue",
        text:
          "We believe a moral compass will always point you in the right direction.",
      },
      {
        color: "green",
        text: "More than educational. Transformational.",
      },
      {
        color: "orange",
        text: "Where a personalized education is never just about one person.",
      },
      {
        color: "red",
        text:
          "We teach students that life is far more than what you do for a living.",
      },
    ],
    images: {
      catholicSchools: "Catholic Schools Archdiocese of Boston",
      goFuther: "Go Further with Faith",
    },
    video: {
      videoCode: "296087109",
      videoFirstTitle: "PLAY",
      videoSecondTitle: "VIDEO",
    },
    social: {
      facebook: "https://www.facebook.com/CSOBoston/",
      twitter: "https://twitter.com/CSOboston",
      instagram: "https://www.instagram.com/csoboston/",
    },
    "intro-band": {
      title:
        "We believe that a Catholic school education best prepares students to be productive, engaged citizens.",
      content:
        "Our supportive community of educators, parents and students develops the academic and moral strengths of every child. Explore our schools below, which are beginning on time and offering in person instruction.",
      subTitle: "Get in touch with Catholic Schools of Boston",
      emailButton: "Email us",
      emailLink:
        "http://www.bostoncatholic.org/About-The-Archdiocese/Contact-Us.aspx?id=262",
      phoneButton: "Call 617.779.3601",
      phoneLink: "tel:6177793601",
    },
  },
  school: [
    {
      admissionLink:
        "https://www.ndatyngsboro.org/apps/pages/index.jsp?uREC_ID=1562273&type=d&pREC_ID=1689364",
      school: "Academy of Notre Dame",
      image: "NotreDameTyngsboro",
      city: "Tyngsboro",
      gender: "Coed",
      address1: "180 Middlesex Road",
      address2: "Tyngsboro, MA 01879",
      phone: "(978) 649-7611",
      phoneLink: "978-649-7611",
      website: "http://www.ndatyngsboro.org",
      maps:
        "https://www.google.com/maps/place/Academy+of+Notre+Dame/@42.6705919,-71.4285296,17z/data=!3m1!4b1!4m5!3m4!1s0x89e3bb0507b21579:0x18cec45d25aef0b8!8m2!3d42.670588!4d-71.4263409",
      description1:
        "The Academy of Notre Dame (also referred to as NDA) is a private, Catholic co-education Pre-K through Grade 8 Lower School and college-preparatory Upper School for young women sponsored by the Sisters of Notre Dame de Namur and located in Tyngsboro, Massachusetts. Situated along the Merrimack River just eight miles from Lowell on the southern NH border, the Academy's 200-acre campus offers pristine fields, ponds, and forests in which to explore, learn and play. The natural environment provides seclusion and security unique to the area while also being in close proximity to local emergency services. For more than 150 years, students of all backgrounds have attended the Academy for a rich academic and religious education.",
      description2:
        "We are opening September 2 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/2/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink:
        "https://www.ndatyngsboro.org/apps/pages/index.jsp?uREC_ID=1562464&type=d&pREC_ID=1689381",
      school: "Academy of Notre Dame High School",
      image: "NotreDameTyngsboro",
      city: "Tyngsboro",
      gender: "Girls",
      address1: "180 Middlesex Rd",
      address2: "Tyngsboro, MA 01879",
      phone: "(978) 649-7611",
      phoneLink: "978-649-7611",
      website: "http://www.ndatyngsboro.org",
      maps:
        "https://www.google.com/maps/place/Academy+of+Notre+Dame/@42.6705919,-71.4285296,17z/data=!3m1!4b1!4m5!3m4!1s0x89e3bb0507b21579:0x18cec45d25aef0b8!8m2!3d42.670588!4d-71.4263409",
      description1:
        "The Academy of Notre Dame (also referred to as NDA) is a private, Catholic co-education Pre-K through Grade 8 Lower School and college-preparatory Upper School for young women sponsored by the Sisters of Notre Dame de Namur and located in Tyngsboro, Massachusetts. Situated along the Merrimack River just eight miles from Lowell on the southern NH border, the Academy's 200-acre campus offers pristine fields, ponds, and forests in which to explore, learn and play. The natural environment provides seclusion and security unique to the area while also being in close proximity to local emergency services. For more than 150 years, students of all backgrounds have attended the Academy for a rich academic and religious education.",
      description2:
        "We are opening September 2 with 5 days of in-school instruction.",
      attributes: ["9-12", "Start Date: 9/2/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.awhs.org/admissions",
      school: "Archbishop Williams High School",
      image: "ArchbishopWilliams",
      city: "Braintree",
      gender: "Coed",
      address1: "80 Independence Ave,",
      address2: "Braintree, MA 02184",
      phone: "(781) 843-3610",
      phoneLink: "781-843-3610",
      website: "https://www.awhs.org",
      maps:
        "https://www.google.com/maps/place/Archbishop+Williams+High+School/@42.2284704,-71.0045464,19.71z/data=!4m13!1m7!3m6!1s0x89e37d2a918e658b:0x360236ed98371667!2s80+Independence+Ave,+Braintree,+MA+02184,+EE.+UU.!3b1!8m2!3d42.2282813!4d-71.004367!3m4!1s0x89e37d2a9af65ac9:0x36e9d54f26e3c380!8m2!3d42.2281648!4d-71.0043819",
      description1:
        "Archbishop Williams High School is an independent, Catholic, college preparatory, grades 7 through 12 school located in Braintree, MA. Archbishop Williams strives to educate the whole student. Using Catholic values as a guide, AWHS encourages all students to achieve excellence not only in the classroom but on the playing field, as well as through extra-curricular activities, and as members of society.",
      description2:
        "We are opening September 1 with 4 days of in-school instruction.",
      attributes: ["7-12", "Start Date: 9/1/2020", "4 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.achssas.org/admissions/index.cfm",
      school: "Arlington Catholic High School",
      videoUrl: "296087036",
      image: "ArlingtonCatholic",
      city: "Arlington",
      gender: "Coed",
      address1: "16 Medford Street",
      address2: "Arlington, MA 02474",
      phone: "(781) 643-9031",
      phoneLink: "781-643-9031",
      website: "https://www.achs.net",
      maps:
        "https://www.google.com/maps/place/Arlington+Catholic+High+School/@42.415528,-71.150756,3a,75y,90t/data=!3m8!1e2!3m6!1sAF1QipPm_REhl-wHW-2Pquwr_mmiEeDpPxeUuAYA1ifw!2e10!3e12!6shttps:%2F%2Flh5.googleusercontent.com%2Fp%2FAF1QipPm_REhl-wHW-2Pquwr_mmiEeDpPxeUuAYA1ifw%3Dw152-h86-k-no!7i5312!8i2988!4m13!1m7!3m6!1s0x89e37650aab3680d:0x1468da51abc91e86!2s16+Medford+St,+Arlington,+MA+02474!3b1!8m2!3d42.4155003!4d-71.1507002!3m4!1s0x89e3765755538ddf:0x6bd7885757a17482!8m2!3d42.415528!4d-71.150756",
      description1:
        "Arlington Catholic High School, combined with Saint Agnes School, is a Pre-K through grade 12 Catholic School in Arlington, Massachusetts. Founded in 1960, Arlington Catholic joined forces with Saint Agnes School in 2017, combining the rich history of both schools. Arlington Catholic High School/Saint Agnes School fosters strong individual academic achievement and character development, centered on the Catholic faith. The co-educational Pre-K through Grade 12 school nurtures a community of critical thinkers dedicated to integrity, service, and living the Gospel message of Christ in the twenty-first century.",
      description2:
        "We are opening September 14 with a hybrid model of in-school and online instruction.",
      attributes: ["9-12", "Start Date: 9/14/2020", "Hybrid Model"],
    },
    {
      admissionLink: "https://www.austinprep.org/admissions",
      school: "Austin Preparatory School",
      image: "AustinPrep",
      videoUrl: "299541516",
      city: "Reading",
      gender: "Coed",
      address1: "101 Willow Street",
      address2: "Reading, MA 01867",
      phone: "(781) 944-4900",
      phoneLink: "781-944-4900",
      website: "https://www.austinprep.org/",
      maps:
        "https://www.google.com/maps/place/Austin+Preparatory+School/@42.5300264,-71.1294476,17z/data=!4m13!1m7!3m6!1s0x89e30b3bff420a63:0x7382aa5d0156b52!2s101+Willow+St,+Reading,+MA+01867!3b1!8m2!3d42.5300264!4d-71.1272589!3m4!1s0x89e30b3bffca94d7:0xa83f61ed8a955e45!8m2!3d42.530026!4d-71.127259",
      description1:
        "Founded in 1961 by the Augustinian Fathers of the Province of St. Thomas of Villanova and located in Reading, MA, Austin Preparatory School is a Catholic Independent school in the Augustinian tradition serving young men and women in grades 6 through 12.",
      description2:
        "We are opening August 24 with 5 days of in-school instruction.",
      attributes: ["6-12", "Start Date: 8/24/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://bellesiniacademy.org/families/admissions/",
      school: "Bellesini Academy",
      image: "BellesiniAcademy",
      city: "Lawrence",
      gender: "Coed",
      address1: "94 Bradford Street",
      address2: "Lawrence, MA 01840",
      phone: "(978) 989-0004",
      phoneLink: "978-989-0004",
      website: "https://www.bellesiniacademy.org",
      description1:
        "Bellesini Academy is an independent, Catholic middle school located in Lawrence, Massachusetts. Bellesini is committed to identifying and admitting students of all faiths who demonstrate academic promise and fall below the poverty line. The school provides at-risk, inner-city students with the advantages enjoyed by suburban students, including a challenging academic curriculum taught in small classes by highly qualified teachers, a safe and secure school environment, and after-school activities that help students develop non-academic talents and interests. In September 2015 the Academy began admitting female students to a separate “co-institutional” girls school.",
      description2:
        "We are opening September 9 with 5 days of in-school instruction.",
      attributes: ["5-8", "Start Date: 9/9/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.fenwick.org/admission",
      school: "Bishop Fenwick High School",
      image: "BishopFenwick",
      city: "Peabody",
      gender: "Coed",
      address1: "99 Margin Street",
      address2: "Peabody, MA 01960",
      phone: "(978) 587-8300",
      phoneLink: "978-587-8300",
      website: "https://www.fenwick.org",
      maps:
        "https://www.google.com/maps/place/Bishop+Fenwick+High+School/@42.5396755,-70.9180907,17z/data=!4m13!1m7!3m6!1s0x89e313f3b31acce3:0xec2b71b73f3c5f3c!2s99+Margin+St,+Peabody,+MA+01960!3b1!8m2!3d42.5396755!4d-70.915902!3m4!1s0x89e313f20af49f6f:0xee7a1e1116ff9b72!8m2!3d42.5398604!4d-70.9176395",
      description1:
        "Bishop Fenwick High School, established in 1959 in Peabody, Massachusetts, is recognized as one of the finest college preparatory high schools in the area. Maintaining its original mission, Fenwick remains co-ed and exclusively secondary, attracting families from over 40 North Shore communities to its 60-acre campus.",
      description2:
        "We are opening September 8 with 5 days of in-school instruction.",
      attributes: ["9-12", "Start Date: 9/8/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://school.blessedsacrament.org/admissions",
      school: "Blessed Sacrament School",
      image: "BlessedSacramentSchool",
      city: "Walpole",
      gender: "Coed",
      address1: "808 East Street",
      address2: "Walpole, MA 02081",
      phone: "(508) 668-2336",
      phoneLink: "508-668-2336",
      website: "https://school.blessedsacrament.org",
      description1:
        "Blessed Sacrament School is a Pre-K through grade 8 Catholic school located in Walpole, Massachusetts. Established in 1966, Blessed Sacrament works to ensure that each child is assisted in developing spiritually, intellectually, emotionally, and socially in an atmosphere of Christian concern, commitment and service.",
      description2:
        "We are opening September 1 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/1/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.bchigh.edu/enrollment/enrollment-overview/",
      school: "Boston College High School",
      videoUrl: "296445678",
      image: "BCHigh",
      city: "Dorchester",
      city2: "Boston",
      gender: "Boys",
      address1: "150 Morrissey Blvd.",
      address2: "Boston, MA 02125",
      phone: "(617) 436-3900",
      phoneLink: "617-436-3900",
      website: "https://www.bchigh.edu",
      maps:
        "https://www.google.com/maps/place/Boston+College+High+School/@42.31609,-71.0488729,17z/data=!4m13!1m7!3m6!1s0x89e37aff20867af5:0x8c63043910365ec8!2s150+Morrissey+Blvd,+Boston,+MA+02125!3b1!8m2!3d42.31609!4d-71.0466842!3m4!1s0x89e37afebcbaf589:0x780a3b22f0552951!8m2!3d42.3162356!4d-71.0454645",
      description1:
        "Boston College High School is a grade 7 through grade 12, all-boys Catholic high school. Located in the heart of Boston and known for its challenging curriculum, BC High combines contemporary learning models with reflective spirituality to prepare students for the future.",
      description2: "",
      attributes: ["7-12"],
    },
    {
      admissionLink: "https://www.spellman.com/admissions",
      school: "Cardinal Spellman High School",
      videoUrl: "296447614",
      image: "CardinalSpellman",
      city: "Brockton",
      gender: "Coed",
      address1: "738 Court Street",
      address2: "Brockton, MA 02302-2898",
      phone: "(508) 583-6875",
      phoneLink: "508-583-6875",
      website: "https://www.spellman.com",
      maps:
        "https://www.google.com/maps/place/Cardinal+Spellman+High+School/@42.0941752,-70.9959853,17z/data=!4m13!1m7!3m6!1s0x89e49b49d4745243:0x519bcb9be1df518!2s738+Court+St,+Brockton,+MA+02302!3b1!8m2!3d42.0941752!4d-70.9937966!3m4!1s0x89e49b362ea8ebe3:0x654282fb1ef7ac2c!8m2!3d42.0932099!4d-70.9929442",
      description1:
        "Cardinal Spellman is a Catholic college-preparatory co-educational high school for grades 9 through 12, located in Brockton, Massachusetts. Cardinal Spellman is dedicated to providing opportunities for its students to maximize their potential within a Catholic environment. A Spellman education strives to prepare young men and women to achieve academic success, to embrace Gospel values, to respect themselves and others, and to be of service to their community, to their Church, and to the world.",
      description2:
        "We are opening September 8 with 5 days of in-school instruction.",
      attributes: ["9-12", "Start Date: 9/8/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink:
        "https://cathedralhighschool.net/admissions/admissions-overview/",
      school: "Cathedral High School",
      image: "CathedralHigh",
      videoUrl: "296087612",
      city: "Boston",
      gender: "Coed",
      address1: "74 Union Park Street",
      address2: "Boston, MA 02118",
      phone: "(617) 542-2325",
      phoneLink: "617-542-2325",
      website: "https://www.cathedralhighschool.net",
      maps:
        "https://www.google.com/maps/place/Cathedral+High+School/@42.3410039,-71.0709201,17z/data=!4m13!1m7!3m6!1s0x89e37a6c15e31fad:0x1c4c5f8932f94678!2s74+Union+Park+St,+Boston,+MA+02118!3b1!8m2!3d42.3410039!4d-71.0687314!3m4!1s0x89e37a6c16e0d98b:0x76b4b1a120ef441a!8m2!3d42.341004!4d-71.068731",
      description1:
        "Cathedral High School is Boston’s only Catholic coed school serving grades 7 through 12. Situated at a beautiful and safe campus in the historic South End neighborhood, Cathedral engages students in a rigorous and high quality STEAM-based and faith-guided education using an applied learning model.",
      description2:
        "We are opening September 1 with 5 days of in-school instruction.",
      attributes: [
        "Grade: 7-12",
        "Start Date: 9/1/2020",
        "5 Days Live Instruction",
      ],
    },
    {
      admissionLink: "https://www.catholicmemorial.org/admissions",
      school: "Catholic Memorial School",
      videoUrl: "296087612",
      image: "CatholicMemorial",
      city: "West Roxbury",
      city2: "Boston",
      gender: "Boys",
      address1: "235 Baker Street",
      address2: "West Roxbury, MA 02132",
      phone: "(617) 469-8000",
      phoneLink: "617-469-8000",
      website: "https://www.catholicmemorial.org",
      maps:
        "https://www.google.com/maps/place/Catholic+Memorial+School/@42.2776416,-71.1682121,17z/data=!4m13!1m7!3m6!1s0x89e37f3faeaaeaad:0xd4cc9f827e364c30!2s235+Baker+St,+West+Roxbury,+MA+02132!3b1!8m2!3d42.2776416!4d-71.1660234!3m4!1s0x89e37f3f00f507e9:0x3608d1ecff098912!8m2!3d42.2776416!4d-71.1660234",
      description1:
        "Catholic Memorial School (CM) is a college-preparatory school for boys in grades 7 through 12. Since 1957 Catholic Memorial’s faith and learning community has been dedicated to transforming boys' lives through academics, arts, athletics, and campus ministry. Students are challenged to pursue excellence, embrace Gospel values, and lead through service.",
      description2:
        "We are opening August 31 with a hybrid model of in-school and online instruction",
      attributes: ["Grade: 7-12", "Start Date: 8/31/2020", "Hybrid Model"],
    },
    {
      admissionLink: "https://www.centralcatholic.net/admissions",
      school: "Central Catholic High School",
      image: "CentralCatholic",
      videoUrl: "296087894",
      city: "Lawrence",
      gender: "Coed",
      address1: "300 Hampshire Street",
      address2: "Lawrence , MA 01841",
      phone: "(978) 682-0260",
      phoneLink: "978-682-0260",
      website: "https://www.centralcatholic.net",
      maps:
        "https://www.google.com/maps/place/Central+Catholic+High+School/@42.7130001,-71.172891,17z/data=!4m13!1m7!3m6!1s0x89e307756f50aba9:0x1ba6174758e4674d!2s300+Hampshire+St,+Lawrence,+MA+01841!3b1!8m2!3d42.7130001!4d-71.1707023!3m4!1s0x89e30775650d91ef:0xf8d449c1eb70a49d!8m2!3d42.7124676!4d-71.1714017",
      description1:
        "Central Catholic High School is a college preparatory high school of excellence in the Marist tradition. Founded by the Marist Brothers in the heart of Lawrence, Massachusetts, in 1935, Central Catholic High School enrolls 1,200 students from over 60 cities and towns. Students come from diverse backgrounds to form a caring community of faith, learning, and service. They advance to college in overwhelming numbers (nearly 100%) and move on to successful careers and positions of leadership in government, business, industry, academia, and other professions.",
      description2:
        "We are opening September 15 with a hybrid model of in-school and online instruction.",
      attributes: ["9-12", "Start Date: 9/15/2020", "Hybrid Model"],
    },
    {
      admissionLink: "https://www.cheverusschool.com/admissions",
      school: "Cheverus Catholic School",
      image: "CheverusCatholicSchool",
      city: "Malden",
      gender: "Coed",
      address1: "30 Irving Street",
      address2: "Malden, MA 02148",
      phone: "(781) 324-6584",
      phoneLink: "781-324-6584",
      website: "https://www.cheverusschool.com",
      description1:
        "Cheverus Catholic School is a Pre-K through Grade 8 Roman Catholic school located in the community of Malden, Massachusetts. For more than 110 years, Cheverus School has aspired to provide the best Catholic elementary school education possible, through the continuing reflection and assessment of exceptional spiritual and academic programs. Cheverus Catholic of Sacred Hearts Parish exemplifies the kind of academic excellence, spiritual growth, and community spirit that make it the school of choice for families in Malden and surrounding cities and towns.",
      description2:
        "We are opening September 3 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/3/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink:
        "https://www.cristoreyboston.org/apps/pages/index.jsp?uREC_ID=308273&type=d&pREC_ID=1783506",
      school: "Cristo Rey Boston High School",
      image: "CristoRey",
      city: "Dorchester",
      city2: "Boston",
      gender: "Coed",
      address1: "100 Savin Hill Avenue",
      address2: "Dorchester, MA 02124",
      phone: "(617) 825-2580",
      phoneLink: "617-825-2580",
      website: "https://www.cristoreyboston.org/",
      maps:
        "https://www.google.com/maps/place/Cristo+Rey+Boston+High+school/@42.3123915,-71.0533333,19.3z/data=!4m13!1m7!3m6!1s0x89e37bab135dcb35:0x105cdfc4ff7aa389!2s100+Savin+Hill+Ave,+Dorchester,+MA+02125,+EE.+UU.!3b1!8m2!3d42.3123023!4d-71.0539553!3m4!1s0x89e37bab15e75daf:0xf42d6261c3e39bd0!8m2!3d42.3122026!4d-71.0539705",
      description1:
        "Cristo Rey® Boston is a Catholic high school for Grades 9 through 12, located in Dorchester, Massachusetts. Firmly grounded in the Roman Catholic faith, Cristo Rey was founded in 2004 and serves young people who come from a variety of religious traditions. The full experience of Cristo Rey® Boston – work, spirituality, service opportunities, academic rigor, exposure to professionals at work, and the support of faculty and staff – teaches students to live a life with a purpose.",
      description2:
        "We are opening August 24 with 5 days of in-school instruction.",
      attributes: ["9-12", "Start Date: 8/24/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.ebccs.org/enrollment-tuition",
      school: "East Boston Central Catholic School",
      image: "EastBostonCentral",
      city: "East Boston",
      city2: "Boston",
      gender: "Coed",
      address1: "69 London Street",
      address2: "East Boston, MA 02128",
      phone: "(617) 567-7456",
      phoneLink: "617-567-7456",
      website: "https://www.ebccs.org",
      description1:
        "East Boston Central Catholic is a Pre-K through grade 8 Roman Catholic school servicing the needs of East Boston and the surrounding communities. For more than 40 years, East Boston Central Catholic has provided children with the advantage of a safe, conducive learning environment that enriches the lives of students on an academic and spiritual level.",
      description2:
        "We are opening September 2 with a hybrid model of in-school and online instruction.",
      attributes: ["PreK-8", "Start Date: 9/2/2020", "Hybrid Model"],
    },
    {
      admissionLink: "https://www.fontbonneacademy.org/admissions",
      school: "Fontbonne Academy",
      videoUrl: "296088067",
      image: "FontbonneAcademy",
      city: "Milton",
      gender: "Girls",
      address1: "930 Brook Road",
      address2: "Milton, MA 02186",
      phone: "(617) 696-3241",
      phoneLink: "617-696-3241",
      website: "https://www.fontbonneacademy.org",
      maps:
        "https://www.google.com/maps/place/Fontbonne+Academy/@42.259471,-71.0617551,17z/data=!4m13!1m7!3m6!1s0x89e37c668abdc099:0xd2f37342617988b2!2s930+Brook+Rd,+Milton,+MA+02186!3b1!8m2!3d42.259471!4d-71.0595664!3m4!1s0x89e37c668abdc099:0x567ffc1e715b2115!8m2!3d42.2595406!4d-71.0594803",
      description1:
        "Fontbonne, The Early College of Boston is a Catholic high school serving girls in Grades 9 through 12 in Milton, Massachusetts. Since its inception in 1954, Fontbonne has sought to instill in young women, qualities of leadership, intellectual openness, social connection, and spiritual strength that will support them personally and professionally.",
      description2: "",
      attributes: ["9-12"],
    },
    {
      admissionLink: "https://www.holynameparishschool.org/welcome",
      school: "Holy Name Parish School",
      image: "HolyNameParish",
      city: "West Roxbury",
      city2: "Boston",
      gender: "Coed",
      address1: "535 West Roxbury Pkwy",
      address2: "West Roxbury, MA 02132",
      phone: "(617) 325-9338",
      phoneLink: "617-325-9338",
      website: "https://www.holynameparishschool.org/",
      description1:
        "Holy Name Parish School is a Pre-K through Grade 6 Catholic elementary school located in the West Roxbury section of Boston, MA. Holy Name School has a special mission that sets it apart from public schools and most other private schools. In addition to supporting a complete academic curriculum, the school is a faith community that integrates religious instruction, value formation, and faith development into the academic education of its students.",
      description2:
        "We are opening September 8 with 5 days of in-school instruction.",
      attributes: ["PreK-6", "Start Date: 9/8/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://icslowell.com/2014-2015-registration/",
      school: "Immaculate Conception School",
      image: "ImmaculateConceptionLowell",
      city: "Lowell",
      gender: "Coed",
      address1: "218 East Merrimack Street",
      address2: "Lowell, MA 01852",
      phone: "(978) 454-5339",
      phoneLink: "978-454-5339",
      website: "https://www.icslowell.com",
      description1:
        "Immaculate Conception School is a Pre-K through Grade 8 Catholic school located in Lowell, Massachusetts. For over 100 years, IC Lowell has been dedicated to carrying the light of Catholic education. With one of the finest physical plants in Lowell, the Immaculate Conception School, located in the heart of the historic National Park, looks forward to continuing to provide leadership in education and service to the community in which it thrives.",
      description2:
        "We are opening August 25 with 5 days of in-school instruction.",
      attributes: [
        "PreK-8",
        "Start Date: 8/25/2020",
        "5 Days Live Instruction",
      ],
    },
    {
      admissionLink: "https://www.icsnewburyport.com/admission/",
      school: "Immaculate Conception School",
      image: "ImmaculateConceptionNewburyport",
      city: "Newburyport",
      gender: "Coed",
      address1: "One Washington Street",
      address2: "Newburyport, MA 01950",
      phone: "(978) 465-7780",
      phoneLink: "978-465-7780",
      website: "https://www.ICSNewburyport.com",
      description1:
        "The Immaculate Conception School (IC) is a Pre-K through Grade 8 Catholic School. Located in the center of the beautiful historic harborside community of Newburyport, Massachusetts, the IC provides students with the skills to become lifelong learners in a safe, supportive, and creative environment.",
      description2: "We are opening September 2.",
      attributes: ["PreK-8", "Start Date: 9/2/2020"],
    },
    {
      admissionLink: "http://icrevere.org/admissions.shtml",
      school: "Immaculate Conception School",
      image: "ImmaculateConceptionRevere",
      city: "Revere",
      gender: "Coed",
      address1: "127 Winthrop Avenue",
      address2: "Revere, MA 02151",
      phone: "(781) 284-0519",
      phoneLink: "781-284-0519",
      website: "http://www.icrevere.org",
      description1:
        "The Immaculate Conception School is a Pre-K through grade 8 Roman Catholic school located in Revere, Massachusetts. Since 1913, Immaculate Conception School has nurtured each students’ unique intellectual and creative abilities by celebrating those abilities in a Catholic learning community. The school strives diligently to build strong community ties among parents, students and faculty. The school prepares a culturally diverse student population to become responsible, well-rounded, faith-filled citizens, focusing on the Catholic precepts of peace, justice and service to others, while maintaining high academic standards.",
      description2:
        "We are opening September 8 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/8/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://jwpschools.org/change-leads-to-growth/",
      school: "Jackson Walnut Park Schools",
      image: "JacksonWalnutPark",
      city: "Newton",
      gender: "Coed",
      address1: "200 Jackson Road",
      address2: "Newton, MA 02458",
      phone: "(617) 969-1537",
      phoneLink: "617-969-1537",
      website: "https://www.jacksonschool.org",
      description1:
        "Jackson Walnut Park Schools, founded in 1967 by the Sisters of St. Joseph of Boston, is a Montessori early childhood program and a Catholic, growth-centered elementary school located in Newton, close to Newton Corner. Walnut Park Montessori, serving children ages 18 months to six years old, instills joyful learning and excitement for learning in peaceful, respectful, multi-age classrooms. Jackson School educates students Kindergarten through Grade 6 in a dynamic and nurturing academic environment that is serious in its purpose to invigorate imagination, enhance confidence, and build leadership. An expansive after-school program offers children ages three to grade 6 a wide array of enrichment activities.",
      description2:
        "We are opening September 8 with 5 days of in-school instruction.",
      attributes: ["PreK-6", "Start Date: 9/8/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink:
        "https://www.lawrencecatholicacademy.net/admissions-process.html",
      school: "Lawrence Catholic Academy",
      image: "LawrenceCatholicAcademy",
      city: "Lawrence",
      gender: "Coed",
      address1: "101 Parker Street",
      address2: "Lawrence, MA 01843",
      phone: "(978) 683-5822",
      phoneLink: "978-683-5822",
      website: "https://www.lawrencecatholicacademy.org/",
      description1:
        "Lawrence Catholic Academy (LCA) is a Pre-K through grade 8 Catholic school located in the city of Lawrence, Massachusetts. Lawrence Catholic Academy is a collaborative effort of Our Lady of Good Counsel and Saint Patrick Parishes. Bringing together more than 100 years of Catholic educational experience, Lawrence Catholic Academy opened in September 2010 on the site of the former Saint Patrick School. ",
      description2:
        "We are opening September 8 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/8/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink:
        "https://www.lowellcatholic.org/s/400/16/index.aspx?sid=400&gid=1&pgid=893",
      school: "Lowell Catholic",
      videoUrl: "296088234",
      image: "LowellCatholic",
      city: "Lowell",
      gender: "Coed",
      address1: "530 Stevens Street",
      address2: "Lowell, MA 01851",
      phone: "(978) 452-1794",
      phoneLink: "978-452-1794",
      website: "https://www.lowellcatholic.org/",
      maps:
        "https://www.google.com/maps/place/Lowell+Catholic+High+School/@42.6258481,-71.3302965,15.71z/data=!4m13!1m7!3m6!1s0x89e3a3809118c663:0x215162e957253180!2s530+Stevens+St,+Lowell,+MA+01851!3b1!8m2!3d42.62546!4d-71.3308958!3m4!1s0x89e3a3808e0278d3:0x9c9866ca143d2f02!8m2!3d42.6257873!4d-71.3311201",
      description1:
        "Lowell Catholic School is a Pre-K through grade 12 Xaverian Brothers sponsored Catholic school, within the Archdiocese of Boston. Located in Lowell, Massachusetts, Lowell Catholic is committed to providing a challenging Catholic education to students with diverse academic, social, cultural, and economic backgrounds. Lowell provides a safe, caring environment where students can excel, prepare and live.",
      description2:
        "We are opening September 8 with 5 days of in-school instruction.",
      attributes: [
        "Pre-K-12",
        "Start Date: 9/8/2020",
        "5 Days Live Instruction",
      ],
    },
    {
      admissionLink: "https://www.maldencatholic.org/admissions",
      school: "Malden Catholic School for Boys",
      image: "MaldenCatholic",
      videoUrl: "299541566",
      city: "Malden",
      gender: "Boys",
      address1: "99 Crystal Street",
      address2: "Malden, MA 02148",
      phone: "(781) 322-3098",
      phoneLink: "781-322-3098",
      website: "https://www.maldencatholic.org/",
      maps:
        "https://www.google.com/maps/place/Malden+Catholic+High+School/@42.4272261,-71.0485157,17z/data=!4m13!1m7!3m6!1s0x89e3722a67411087:0x4236ffbaf6ee3bd4!2s99+Crystal+St,+Malden,+MA+02148!3b1!8m2!3d42.4272261!4d-71.046327!3m4!1s0x89e3722a652b5f57:0x6023c42f01fdeb7a!8m2!3d42.4272261!4d-71.046327",
      description1:
        "Malden Catholic High School is a codivisional, college-preparatory Catholic high school sponsored by the Xaverian Brothers and located within the Archdiocese of Boston in Malden. Since 1932, Malden Catholic has been dedicated to maintaining a family-like community that forms student-leaders of strong faith and character. Malden Catholic prepares students to achieve excellence in the classroom, on the field, in their extracurricular activities, and in their college and career pursuits.",
      description2:
        "We are opening September 16 with a hybrid model of in-school and online instruction.",
      attributes: ["9-12", "Start Date: 9/16/2020", "Hybrid Model"],
    },
    {
      admissionLink: "https://www.maldencatholic.org/admissions",
      school: "Malden Catholic School for Girls",
      image: "MaldenCatholic",
      videoUrl: "299541566",
      city: "Malden",
      gender: "Girls",
      address1: "99 Crystal Street",
      address2: "Malden, MA 02148",
      phone: "(781) 322-3098",
      phoneLink: "781-322-3098",
      website: "https://www.maldencatholic.org/",
      maps:
        "https://www.google.com/maps/place/Malden+Catholic+High+School/@42.4272261,-71.0485157,17z/data=!4m13!1m7!3m6!1s0x89e3722a67411087:0x4236ffbaf6ee3bd4!2s99+Crystal+St,+Malden,+MA+02148!3b1!8m2!3d42.4272261!4d-71.046327!3m4!1s0x89e3722a652b5f57:0x6023c42f01fdeb7a!8m2!3d42.4272261!4d-71.046327",
      description1:
        "Malden Catholic High School is a codivisional, college-preparatory Catholic high school sponsored by the Xaverian Brothers and located within the Archdiocese of Boston in Malden. Since 1932, Malden Catholic has been dedicated to maintaining a family-like community that forms student-leaders of strong faith and character. Malden Catholic prepares students to achieve excellence in the classroom, on the field, in their extracurricular activities, and in their college and career pursuits.",
      description2:
        "We are opening September 16 with a hybrid model of in-school and online instruction.",
      attributes: ["9-12", "Start Date: 9/16/2020", "Hybrid Model"],
    },
    {
      admissionLink: "https://www.matignon.org/admissions/index.cfm",
      school: "Matignon High School",
      videoUrl: "296088674",
      image: "Matignon",
      city: "Cambridge",
      gender: "Coed",
      address1: "One Matignon Road",
      address2: "Cambridge, MA 02140",
      phone: "(617) 876-1212",
      phoneLink: "617-876-1212",
      website: "https://www.matignon-hs.org",
      maps:
        "https://www.google.com/maps/place/Matignon+High+School/@42.4015331,-71.1335789,17z/data=!4m13!1m7!3m6!1s0x89e3771d159cedfd:0x827a387f9f30433a!2s1+Matignon+Rd,+Cambridge,+MA+02140!3b1!8m2!3d42.4015331!4d-71.1313902!3m4!1s0x89e3771d3cad97a3:0xe96d22e0af71d0db!8m2!3d42.4016029!4d-71.1313553",
      description1:
        "Matignon High School is an independent Catholic, co-ed, college preparatory school celebrating 70 years of service to Greater Boston by empowering students through an intimate, faith-filled education. Matignon High School is a faith-filled, mission-driven, and highly diverse community of nearly five hundred student and faculty learners.",
      description2:
        "We are opening September 8 with a hybrid model of in-school and online instruction",
      attributes: ["9-12", "Start Date: 9/8/2020", "Hybrid Model"],
    },
    {
      admissionLink: "https://www.mcaec.org/the-academy/admission/",
      school: "Mother Caroline Academy",
      image: "MotherCarolineAcademy",
      city: "Dorchester",
      city2: "Boston",
      gender: "Girls",
      address1: "515 Blue Hill Avenue",
      address2: "Dorchester, MA 02121",
      phone: "(617) 427-1177",
      phoneLink: "617-427-1177",
      website: "http://www.mcaec.org",
      description1:
        "In 1993, Mother Caroline Academy (MCA), a middle school for girls (grades 5 – 8) opened its doors and welcomed the first class into a small converted convent on Bird Street in Dorchester. With a commitment to Boston families with limited financial means, MCA was established to provide a high quality education and prepare girls for competitive secondary schools and has been a center of hope and opportunity for the community.",
      description2:
        "We are opening September 3 with 5 days of in-school instruction.",
      attributes: ["4-8", "Start Date: 9/3/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.maa.school/apps/pages/admissions",
      school: "Mount Alvernia Academy",
      image: "MountAlverniaAcademy",
      city: "Newton",
      gender: "Coed",
      address1: "20 Manet Road",
      address2: "Newton, MA 02467",
      phone: "(617) 527-7540",
      phoneLink: "617-527-7540",
      website: "https://www.maa.school/",
      description1:
        "Mount Alvernia Academy (MAA) is a Pre-K through Grade 6 Catholic School located in Chestnut Hill, MA. Mount Alvernia Academy is a community of lifelong learners committed to educating the whole child spiritually, intellectually, and emotionally. The school cultivates a challenging and nurturing environment where children are inspired to discover and share their God-given gifts and talents to make the world a better place.",
      description2:
        "We are opening September 8 with 5 days of in-school instruction.",
      attributes: ["PreK-6", "Start Date: 9/8/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "http://www.mountalverniahs.org/admissions/",
      school: "Mount Alvernia High School",
      videoUrl: "296088371",
      image: "MtAlvernia",
      city: "Newton",
      gender: "Girls",
      address1: "790 Centre Street",
      address2: "Newton, MA 02458",
      phone: "(617) 969-2260",
      phoneLink: "617-969-2260",
      website: "http://www.mountalverniahs.org/",
      maps:
        "https://www.google.com/maps/place/Mount+Alvernia+High+School/@42.3442971,-71.190714,17z/data=!3m1!4b1!4m5!3m4!1s0x89e37879bb7f09d1:0x865adc88a9eb1cd1!8m2!3d42.3442971!4d-71.1885253",
      description1:
        "Mount Alvernia High School is a Grade 7 through 12 private Catholic high school located in Newton, Massachusetts. During a student's time at 790 Centre Street, she is challenged by a rigorous curriculum and supported by caring faculty members who believe in the ability of every student to learn at high levels. Over the course of her six years, she develops a strong voice and sense of self-efficacy that allows her to encounter challenges and leverage her strengths in order to develop her growth areas, and overcome challenges.",
      description2:
        "We are opening September 10 with a hybrid model of in-school and online instruction",
      attributes: ["7-12", "Start Date: 9/10/2020", "Hybrid Model"],
    },
    {
      admissionLink: "https://www.nativityboston.org/contact-admissions/",
      school: "Nativity Preparatory School",
      image: "NativityPreparatorySchool",
      city: "Jamaica Plain",
      city2: "Boston",
      gender: "Boys",
      address1: "39 Lamartine Street",
      address2: "Jamaica Plain, MA 02130",
      phone: "(857) 728-0031",
      phoneLink: "857-728-0031",
      website: "https://www.nativityboston.org/",
      description1:
        "Nativity Preparatory School is a grade 4 through grade 8 Catholic middle school for boys located in the Boston neighborhood of Jamaica Plain and serving boys from low-income families residing in Boston. This tuition-free school is made possible entirely through the generosity of supporters. Nativity’s academically challenging and highly structured environment promotes the intellectual, spiritual, social, and physical growth that inspires boys to become successful and compassionate “men for others” and that breaks the cycle of poverty.",
      description2:
        "We are opening September 10 with a hybrid model of in-school and online instruction",
      attributes: ["4-8", "Start Date: 9/10/2020", "Hybrid Model"],
    },
    {
      admissionLink: "https://www.newtoncountryday.org/admission",
      school: "Newton Country Day School of the Sacred Heart",
      image: "NewtonCountryDay",
      city: "Newton",
      gender: "Girls",
      address1: "785 Centre Street",
      address2: "Newton, MA 02458",
      phone: "(617) 244-4246",
      phoneLink: "617-244-4246",
      website: "https://www.newtoncountryday.org/",
      maps:
        "https://www.google.com/maps/place/Newton+Country+Day+School+of+the+Sacred+Heart/@42.3454989,-71.1934517,17z/data=!3m1!4b1!4m5!3m4!1s0x89e37878483cf7bb:0xdeeda68d1dce4992!8m2!3d42.345495!4d-71.191263",
      description1:
        "Established in 1880, Newton Country Day School is one of the oldest independent Catholic girls' schools in New England. In its 137th year of educating 'the whole woman with a view to the age and circumstances in which she lives,' Newton welcomes students who may choose from over 120 different courses (including 21 that are Advanced Placement) offered in nine academic departments. Newton’s academically rigorous programs, together with robust athletic, artistic and other extra-curricular offerings, provide for our girls the opportunity to identify what inspires each of them.",
      description2: "",
      attributes: ["5-12"],
    },
    {
      admissionLink: "https://www.ndahingham.com/admissions",
      school: "Notre Dame Academy",
      videoUrl: "296088851",
      image: "NotreDameAcademy",
      city: "Hingham",
      gender: "Girls",
      address1: "1073 Main Street",
      address2: "Hingham, MA 02043",
      phone: "(781) 749-5930",
      phoneLink: "781-749-5930",
      website: "https://www.ndahingham.com/",
      maps:
        "https://www.google.com/maps/place/Notre+Dame+Academy/@42.1848943,-70.8901153,17z/data=!4m8!1m2!2m1!1s1073+Main+Street++Hingham,+MA!3m4!1s0x89e361e959cf1027:0x7e235f341a96bd7d!8m2!3d42.1852131!4d-70.8885621",
      description1:
        "Notre Dame Academy (NDA) located in Hingham, Massachusetts, is a Catholic school for young women in Grades 7 through 12. Notre Dame Academy is a vibrant, Catholic, college-prep learning community that guides young women in shaping their personal faith as they pursue academic excellence and social responsibility.",
      description2:
        "We are opening September 14 with a hybrid model of in-school and online instruction",
      attributes: ["7-12", "Start Date: 9/14/2020", "Hybrid Model"],
    },
    {
      admissionLink:
        "https://www.ndcrhs.org/apps/pages/index.jsp?uREC_ID=376439&type=d&pREC_ID=1216655",
      school: "Notre Dame Cristo Rey High School",
      image: "NotreDameCristoRey",
      city: "Lawrence",
      gender: "Coed",
      address1: "303 Haverhill Street",
      address2: "Lawrence, MA 01843",
      phone: "(978) 689-8222",
      phoneLink: "978-689-8222",
      website: "http://www.ndcrhs.org/",
      maps:
        "https://www.google.com/maps/place/Notre+Dame+Cristo+Rey+High+School/@42.7100998,-71.1691855,17z/data=!3m1!4b1!4m5!3m4!1s0x89e307a03184d021:0x9123d7f633492d4f!8m2!3d42.7100959!4d-71.1669968",
      description1:
        "Notre Dame Cristo Rey High School, located in the heart of Lawrence, Massachusetts, is a Catholic, college preparatory high school serving low-income, predominantly minority youth in Grades 9-12. The school offers students the opportunity to earn a portion of their tuition through its Corporate Work Study Program while also preparing them for higher education through a college preparatory curriculum.",
      description2: "",
      attributes: ["9-12"],
    },
    {
      admissionLink: "http://missiongrammar.org/how-to-apply/",
      school: "Our Lady of Perpetual Help Mission Grammar School",
      image: "OurLadysAcademy",
      city: "Roxbury",
      city2: "Boston",
      gender: "Coed",
      address1: "94 St. Alphonsus Street",
      address2: "Roxbury, MA 02120",
      phone: "(617) 442-2660",
      phoneLink: "617-442-2660",
      website: "http://www.missiongrammar.org",
      description1:
        "Our Lady of Perpetual Help, Mission Grammar School is an infant through grade 6 Catholic school located in the Boston neighborhood of Roxbury. Since 1889, Mission Grammar has been providing a faith-based learning community committed to celebrating the gifts of each child. In a society characterized by diversity, Mission Grammar commits itself to inspire in each student a desire to build just and enriching relationships. The entire school community works to develop a deep prayer life, a commitment to helping others, and an eagerness to spread the message of Christ. Planted in Catholic roots, the school helps children grow in a learning community celebrating the Word of the Gospel.",
      description2:
        "We are opening September 9 with 5 days of in-school instruction.",
      attributes: [
        "Infants-6",
        "Start Date: 9/9/2020",
        "5 Days Live Instruction",
      ],
    },
    {
      admissionLink: "http://www.olalynnfieldschool.com/admission.html",
      school: "Our Lady of the Assumption School",
      image: "OurLadyAssumption",
      city: "Lynnfield",
      gender: "Coed",
      address1: "40 Grove Street",
      address2: "Lynnfield, MA 01940",
      phone: "(781) 599-4422",
      phoneLink: "781-599-4422",
      website: "https://www.olalynnfieldschool.com",
      description1:
        "Our Lady of the Assumption (OLA) is a Preschool through 8th grade Catholic school located north of Boston in Lynnfield, Massachusetts, where routes 1 and 128 meet. Our Lady of the Assumption School was founded by the Sisters of St. Francis of Philadelphia in 1961 to focus on the total development of the student through academic excellence and spiritual growth.",
      description2:
        "We are opening September 2 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/2/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink:
        "https://www.ourladysacademy.org/about-us/admissions/how-to-apply/",
      school: "Our Lady's Academy",
      image: "OurLadyPerpetualHelp",
      city: "Waltham",
      gender: "Coed",
      address1: "920 Trapelo Road",
      address2: "Waltham, MA 02452",
      phone: "(781) 899-0353",
      phoneLink: "781-899-0353",
      website: "https://www.ourladysacademy.org",
      description1:
        "Our Lady’s Academy is a Pre-K through Grade 8 Catholic school located in Waltham,  Massachusetts. Our Lady’s Academy believes that if children are given the necessary tools to succeed, they will soar far beyond their wildest dreams. This success is accomplished by providing all students with a liberal arts education anchored in Catholic traditions. Students are offered an innovative and challenging curriculum that is taught in small classes and tailored to each child’s needs.  Our Lady’s strives to provide an environment that supports the academic, artistic, athletic, social and faith needs of the students as they grow to young adults. These needs are met within a welcoming and nurturing community of faculty and parents that is supported by a strong culture of Catholic traditions and values.",
      description2:
        "We are opening September 8 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/8/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "http://www.quincycatholicacademy.org/admissions/",
      school: "Quincy Catholic Academy",
      image: "QuincyCatholicAcademy",
      city: "Quincy",
      gender: "Coed",
      address1: "370 Hancock Street",
      address2: "Quincy, MA 02171",
      phone: "(617) 328-3830",
      phoneLink: "617-328-3830",
      website: "https://www.quincycatholicacademy.org",
      description1:
        "Quincy Catholic Academy (QCA) serves students from Preschool (age 3) through Grade 8 from many different South Shore cities and towns and the city of Boston. QCA has developed a challenging academic program that builds the foundation for intellectual growth, personal development and lifelong learning. The Academy is committed to ensuring that all students receive a quality education while integrating faith and values formation and encouraging service to others.",
      description2:
        "We are opening September 2 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/2/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.sacredheartkingston.com/#admission",
      school: "Sacred Heart Elementary School",
      image: "SacredHeartKingston",
      city: "Kingston",
      gender: "Coed",
      address1: "329 Bishops Highway",
      address2: "Kingston, MA 02364",
      phone: "(781) 585-2114",
      phoneLink: "781-585-2114 ",
      website: "https://www.sacredheartkingston.com/",
      description1:
        "Sacred Heart School is a grade Pre-K through grade 6 Catholic school located in Kingston, Massachusetts. For the past 70 years, Sacred Heart has been a welcoming, respectful community that is academically challenging and rooted in the Gospel.",
      description2:
        "We are opening August 31 with 5 days of in-school instruction.",
      attributes: [
        "PreK-8",
        "Start Date: 8/31/2020",
        "5 Days Live Instruction",
      ],
    },
    {
      admissionLink: "https://www.sacredheartschoollynn.org/admissions",
      school: "Sacred Heart Elementary School",
      image: "SacredHeartLynn",
      city: "Lynn",
      gender: "Coed",
      address1: "581 Boston Street",
      address2: "Lynn, MA 01905",
      phone: "(781) 592-7581",
      phoneLink: "781-592-7581",
      website: "https://www.sacredheartschoollynn.org",
      description1:
        "Sacred Heart School, located in Lynn, Massachusetts, is a 2.9 through Grade 5 Catholic School. Since 1902, Sacred Heart has been committed to the education of children through the Gospel message of Jesus.",
      description2:
        "We are opening September 1 with 5 days of in-school instruction.",
      attributes: ["PreK-5", "Start Date: 9/1/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink:
        "https://www.sacredheart-boston.org/admissions-information",
      school: "Sacred Heart School",
      image: "SacredHeartSchoolRoslindale",
      city: "Roslindale",
      city2: "Boston",
      gender: "Coed",
      address1: "1035 Canterbury Street",
      address2: "Roslindale, MA 02131",
      phone: "(617) 323-2500",
      phoneLink: "617-323-2500",
      website: "https://www.sacredheart-boston.org/",
      description1:
        "Sacred Heart School is a 2.9-year-old through Grade 8 Catholic elementary school located in the Boston neighborhood of Roslindale. For 100 years, Sacred Heart has continued to innovate its curriculum to mirror the changing world, a STREAM school with emphasis on science, technology, religion, engineering, arts and math interwoven throughout the curriculum.",
      description2:
        "We are opening September 9 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/9/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "http://www.sacredheartschoolweymouth.org/admissions/",
      school: "Sacred Heart School",
      image: "SacredHeartSchoolWeymouth",
      city: "Weymouth",
      gender: "Coed",
      address1: "234 Pleasant Street",
      address2: "Weymouth, MA 02190",
      phone: "(781) 335-6868",
      phoneLink: "781-335-6868",
      website: "http://www.sacredheartschoolweymouth.org/",
      description1:
        "Sacred Heart School is a Pre-K through Grade 4 Catholic elementary school founded by the Sisters of St. Joseph located in Weymouth, Massachusetts. Since opening in 1913, the school has served generations of students with an excellent academic foundation rooted in our Catholic faith.",
      description2:
        "We are opening September 8 with 5 days of in-school instruction.",
      attributes: [
        "5-8",
        "Grades PreK-4",
        "Start Date: 9/8/2020",
        "5 Days Live Instruction",
      ],
    },
    {
      admissionLink: "http://www.sacredheartsbradford.org/Home_Admissions.html",
      school: "Sacred Hearts School",
      image: "SacredHeartSchoolHaverhill",
      city: "Haverhill",
      gender: "Coed",
      address1: "31 South Chestnut Street",
      address2: "Haverhill, MA 01835",
      phone: "(978) 372-5451",
      phoneLink: "978-372-5451",
      website: "http://www.sacredheartsbradford.org/Home.html",
      description1:
        "Sacred Hearts School is a Catholic educational institution open to children from age 3 through grade 8, located in Bradford, Massachusetts, under the dominion of Sacred Hearts Parish Bradford/Groveland. For 80 years, Sacred Hearts has provided a classical elementary education to children in neighboring communities with a commitment to teaching God’s message of salvation.",
      description2:
        "We are opening September 9 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/9/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "http://www.sbcatholicacademy.org/admissions/overview/",
      school: "South Boston Catholic Academy",
      image: "SouthBostonCatholicAcademy",
      city: "South Boston",
      city2: "Boston",
      gender: "Coed",
      address1: "866 East Broadway",
      address2: "South Boston, MA 02127",
      phone: "(617) 268-2326",
      phoneLink: "617-268-2326",
      website: "http://www.sbcatholicacademy.org/",
      description1:
        "South Boston Catholic Academy is a Pre-K through Grade 6 Catholic elementary school located in South Boston, Massachusetts. For many years South Boston Catholic Academy has served the Boston area community with a focus on faith, family and academic excellence.",
      description2:
        "We are opening August 25 with 5 days of in-school instruction.",
      attributes: [
        "PreK-6",
        "Start Date: 8/25/2020",
        "5 Days Live Instruction",
      ],
    },
    {
      admissionLink: "https://stagatha.org/request-information",
      school: "Saint Agatha School",
      image: "SaintAgathaSchool",
      city: "Milton",
      gender: "Coed",
      address1: "440 Adams Street",
      address2: "Milton, MA 02186",
      phone: "(617) 696-3548",
      phoneLink: "617-696-3548",
      website: "https://stagatha.org/",
      maps: "",
      description1:
        "Saint Agatha School, located in Milton, Massachusetts, is an exceptional school for boys and girls Pre-K through grade 8. It is a nurturing environment offering a faith-based education, teaching that stimulates vibrant learning and academic excellence, a strong community where the whole family is embraced and every child is prepared to be his or her best self in today’s world.",
      description2:
        "We are opening September 2 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/2/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.achssas.org/admissions/index.cfm",
      school: "Saint Agnes School",
      image: "SaintAgnesSchool",
      city: "Arlington",
      gender: "Coed",
      address1: "39 Medford Street",
      address2: "Arlington, MA 02474",
      phone: "(781) 643-9031",
      phoneLink: "781-643-9031",
      website: "https://www.saintagnesschool.com",
      maps: "",
      description1:
        "Saint Agnes School is a Pre-K through grade 8 Catholic School in Arlington, Massachusetts. Established in 1888, Saint Agnes joined forces with Arlington Catholic High School in 2017, making the entire school Pre-K through grade 12. ",
      description2:
        "We are opening September 14 with 5 days of in-school instruction.",
      attributes: [
        "PreK-8",
        "Start Date: 9/14/2020",
        "5 Days Live Instruction",
      ],
    },
    {
      admissionLink: "http://www.saseverett.com/enrollmentinformation.html",
      school: "Saint Anthony School",
      image: "SaintAnthonySchool",
      city: "Everett",
      gender: "Coed",
      address1: "54 Oakes Street",
      address2: "Everett, MA 02149",
      phone: "(617) 389-2448",
      phoneLink: "617-389-2448",
      website: "https://www.saseverett.com",
      maps: "",
      description1:
        "Saint Anthony School is a Pre-K through Grade 8 Roman Catholic school located in Everett, Massachusetts. For the past 60 years, Saint Anthony School has been dedicated to providing a program that aims to develop the academic potential of its students. The school endeavors to provide a strong academic program while integrating Christian values as an essential part of the learning environment. ",
      description2:
        "We are opening September 9 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/9/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.staugustineandover.org/admissions/",
      school: "Saint Augustine School",
      image: "SaintAugustineSchool",
      city: "Andover",
      gender: "Coed",
      address1: "26 Central Street",
      address2: "Andover, MA 01810",
      phone: "(978) 475-2414",
      phoneLink: "978-475-2414",
      website: "https://www.staugustineandover.org/",
      maps: "",
      description1:
        "Saint Augustine School is a Pre-K through Grade 8 Catholic elementary school located in Andover, Massachusetts. Saint Augustine School has been a proud tradition of the Andover community for over 100 years, preparing students spiritually, emotionally, socially and academically.",
      description2:
        "We are opening September 8 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/8/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.stbca.org/admission/",
      school: "Saint Benedict Elementary School",
      image: "SaintBenedictElementarySchool",
      city: "South Natick",
      gender: "Coed",
      address1: "2 Pleasant Street South",
      address2: "South Natick, MA 01760",
      phone: "(508) 650-1900",
      phoneLink: "508-650-1900",
      website: "https://www.stbca.org/",
      maps: "",
      description1:
        "Saint Benedict Elementary School is a co-educational independent school that offers a classical education in the Catholic tradition for students in Pre-Kindergarten through Grade 6. Located in Natick, Massachusetts, Saint Benedict Elementary strives to cultivate intellectual and moral virtue in the pursuit of academic excellence, in a joyful and faithful Catholic environment.",
      description2:
        "We are opening September 8 with 5 days of in-school instruction.",
      attributes: ["PreK-6", "Start Date: 9/8/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.stbrendanschool.org",
      school: "Saint Brendan School",
      image: "SaintBrendanSchool",
      city: "Dorchester",
      city2: "Boston",
      gender: "Coed",
      address1: "29 Rita Road",
      address2: "Dorchester, MA 02124",
      phone: "(617) 282-3388",
      phoneLink: "617-282-3388",
      website: "https://www.stbrendanschool.org",
      maps: "",
      description1:
        "Saint Brendan School is a Pre-K through Grade 6 Catholic elementary school in the Boston neighborhood of Dorchester. Since 1951, Saint Brendan School has served as a neighborhood parish school, educating and nurturing students in a safe environment rich in Catholic identity and tradition.",
      description2:
        "We are opening August 31 with 5 days of in-school instruction.",
      attributes: [
        "PreK-6",
        "Start Date: 8/31/2020",
        "5 Days Live Instruction",
      ],
    },
    {
      admissionLink: "https://www.stbridgetschool.us/admissions",
      school: "Saint Bridget School",
      image: "SaintBridgetSchoolAbington",
      city: "Abington",
      gender: "Coed",
      address1: "455 Plymouth Street",
      address2: "Abington, MA 02351",
      phone: "(781) 878-8482",
      phoneLink: "781-878-8482",
      website: "https://www.stbridgetschool.us",
      maps: "",
      description1:
        "Saint Bridget School is a Pre-K through Grade 8 Catholic elementary school located in Abington, Massachusetts. Since 1961, families have chosen to send their children to Saint Bridget School for its reputation as a leader in education as it fosters in its students both the ability and the desire to make a positive difference in the world. This reputation is based on: excellent teachers, academics, respect, spirituality, leadership and character.",
      description2:
        "We are opening September 8 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/8/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "http://www.saintbridgetschool.info/admissions/",
      school: "Saint Bridget School",
      image: "SaintBridgetSchoolFramingham",
      city: "Framingham",
      gender: "Coed",
      address1: "832 Worcester Road",
      address2: "Framingham, MA 01702",
      phone: "(508) 875-0181",
      phoneLink: "508-875-0181",
      website: "http://www.saintbridgetschool.info/",
      maps: "",
      description1:
        "Saint Bridget School is a PreSchool through grade 8 Catholic elementary school, located in Framingham, Massachusetts. For 60 years, Saint Bridget School has provided a classical education blended with traditional Catholic values that make faith-based education so successful.  This is truly an environment where families know one another and care deeply about the school and all of the children’s complete education and spiritual development. Families and students experience the curriculum together and benefit from a competitive academic environment.",
      description2:
        "We are opening September 8 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/8/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "http://www.scsnorwood.com/admissions/",
      school: "Saint Catherine of Siena School",
      image: "SaintCatherineofSienaSchool",
      city: "Norwood",
      gender: "Coed",
      address1: "249 Nahatan Street",
      address2: "Norwood, MA 02062",
      phone: "(781) 769-5354",
      phoneLink: "781-769-5354",
      website: "http://www.scsnorwood.com",
      maps: "",
      description1:
        "Saint Catherine of Siena School is a Preschool through grade 8 Catholic elementary school located in Norwood, Massachusetts. For over nine decades, Saint Catherine of Siena School has served the children and families of Norwood and surrounding towns by providing them with a superior academic education infused with the light of faith.  ",
      description2:
        "We are opening September 2 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/2/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://saintcharleswoburn.com/admissions-registration/",
      school: "Saint Charles Elementary School",
      image: "SaintCharlesElementarySchool",
      city: "Woburn",
      gender: "Coed",
      address1: "8 Myrtle Street",
      address2: "Woburn, MA 01801",
      phone: "(781) 935-4635",
      phoneLink: "781-935-4635",
      website: "https://www.saintcharlesschool.us",
      maps: "",
      description1:
        "Saint Charles School is a Pre-K through Grade 8 Catholic elementary school located in Woburn, Massachusetts. Saint Charles has a storied tradition of excellence. As part of the Saint Charles community, the entire family benefits from a commitment to teaching respect, honor, service, faith and effort. These five core values drive everything the school does, resulting in the development of strong character, good citizenship, and an overall wonderful community.",
      description2:
        "We are opening September 9 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/9/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://stcps.org/visit-apply/",
      school: "Saint Columbkille Partnership School",
      image: "SaintColumbkillePartnership",
      city: "Brighton",
      city2: "Boston",
      gender: "Coed",
      address1: "25 Arlington Street",
      address2: "Brighton, MA 02135",
      phone: "(617) 254-3110",
      phoneLink: "617-254-3110",
      website: "https://stcps.org/",
      maps: "",
      description1:
        "Saint Columbkille Partnership School is a Pre-K through grade 8 Roman Catholic school located in the Allston-Brighton neighborhood of Boston. For more than 115 years, Saint Columbkille has been a mainstay within its surrounding community and has educated children for many generations.",
      description2:
        "We are opening September 2 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/2/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.sfxschoolwey.org/admissions/",
      school: "Saint Francis Xavier School",
      image: "SaintFrancisXavierSchool",
      city: "Weymouth",
      gender: "Coed",
      address1: "234 Pleasant Street",
      address2: "Weymouth, MA 02190",
      phone: "(781) 335-6868",
      phoneLink: "781-335-6868",
      website: "https://www.sfxschoolwey.org/",
      maps: "",
      description1:
        "Saint Francis Xavier School is a grade 5 through 8 Roman Catholic school located in South Weymouth, Massachusetts. Since 1958 Saint Francis Xavier School has prepared students for an exemplary high school career with a rigorous academic curriculum grounded in the Gospel values of Jesus Christ.",
      description2:
        "We are opening September 8 with 5 days of in-school instruction.",
      attributes: ["5-8", "Start Date: 9/8/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.sjsne.com/why-enroll",
      school: "Saint John School",
      image: "StJohnsPreparatorySchool",
      city: "Boston",
      gender: "Coed",
      address1: "9 Moon Street",
      address2: "Boston, MA 02113",
      phone: "(617) 227-3143",
      phoneLink: "617-227-3143",
      website: "https://www.sjsne.com",
      maps: "",
      description1:
        "Saint John School is a Pre-K through Grade 8 Catholic elementary school located in Boston, Massachusetts. Nestled in the heart of Boston’s North End, Saint John School has educated students for bright futures since 1895.  Saint John School offers a unique balance of structure, inspiration, and room to fly. While rooted in Catholic tradition, the school community is open to families of all backgrounds who understand the importance of building a child’s character as much as building knowledge. The Saint John approach teaches children to “do the right thing” as they master new subjects, stretch their wings, and develop a critical and curious mind.  With the support and guidance of their teachers, they explore their true selves, develop confidence while exhibiting kindness, and push the reaches of their imagination and potential. In a close-knit school that takes full advantage of the vibrant cultural offerings just outside its door, students are prepared to become not just successful learners, but also kind, confident citizens of the world.",
      description2:
        "We are opening September 9 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/9/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.sjp2ca.org/admissions/admissions-overview/",
      school: "St. John Paul II Catholic Academy",
      image: "StJohnPaulCatholicAcademyColumbia",
      city: "Dorchester",
      city2: "Boston",
      gender: "Coed",
      address1: "790 Columbia Road",
      address2: "Dorchester, MA 02125",
      phone: "(617) 265-0019 ext 7101",
      phoneLink: "617-265-0019",
      website: "https://www.sjp2ca.org/columbia-campus/",
      maps: "",
      description1:
        "Saint John Paul II Catholic Academy Columbia Campus is a Pre-K through Grade 8 Catholic elementary school located near the Uphams Corner and Savin Hill sections of Dorchester, Massachusetts. The unique location also borders South Boston. Every student at Saint John Paul II Catholic Academy is known and loved. As a result, children are prepared spiritually, academically, physically, emotionally and socially to lead a rich, meaningful life in service to others. The Academy is open to families of all faiths and backgrounds. The education, rooted in Catholicism, focuses on the universal values of love, kindness, compassion, equality, justice and service to others.",
      description2:
        "We are opening September 9 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/9/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.sjp2ca.org/admissions/admissions-overview/",
      school: "St. John Paul II Catholic Academy",
      image: "StJohnPaulCatholicAcademyLowerMills",
      city: "Dorchester",
      city2: "Boston",
      gender: "Coed",
      address1: "2214 Dorchester Avenue",
      address2: "Dorchester, MA 02124",
      phone: "(617) 265-0019 ext 7177",
      phoneLink: "617-265-0019",
      website: "https://www.sjp2ca.org/lower-mills-campus/",
      maps: "",
      description1:
        "Saint John Paul II Catholic Academy Lower Mills Campus is a Pre-K through Grade 8 Catholic elementary school located in the Lower Mills section of Dorchester and close to Mattapan. Every student at Saint John Paul II Catholic Academy is known and loved. As a result, children are prepared spiritually, academically, physically, emotionally and socially to lead a rich, meaningful life in service to others. The Academy is open to families of all faiths and backgrounds. The education, rooted in Catholicism, focuses on such universal values as love, kindness, compassion, equality, justice and service to others.",
      description2:
        "We are opening September 9 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/9/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.sjp2ca.org/admissions/admissions-overview/",
      school: "St. John Paul II Catholic Academy",
      image: "StJohnPaulCatholicAcademyNeponset",
      city: "Dorchester",
      city2: "Boston",
      gender: "Coed",
      address1: "239 Neponset Avenue",
      address2: "Dorchester, MA 02122",
      phone: "(617)-265-0019 ext 7127",
      phoneLink: "617-265-0019",
      website: "https://www.sjp2ca.org/neponset-campus/",
      maps: "",
      description1:
        "Saint John Paul II Catholic Academy Neponset Campus is a Pre-K through Grade 8 Catholic elementary school located in the Neponset section of Dorchester, Massachusetts. Every student at Saint John Paul II Catholic Academy is known and loved. As a result, children are prepared spiritually, academically, physically, emotionally and socially to lead a rich, meaningful life in service to others. The Academy is open to families of all faiths and backgrounds. The education, rooted in Catholicism, focuses on such universal values as love, kindness, compassion, equality, justice and service to others.",
      description2:
        "We are opening September 9 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/9/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://stjohns-peabody.com/admissions/",
      school: "Saint John the Baptist School",
      image: "SaintJohntheBaptistSchool",
      city: "Peabody",
      gender: "Coed",
      address1: "19 Chestnut Street",
      address2: "Peabody, MA 01960",
      phone: "(978) 531-0444",
      phoneLink: "978-531-0444",
      website: "https://stjohns-peabody.com/",
      maps: "",
      description1:
        "Saint John the Baptist School is a Pre-K through Grade 8 Catholic elementary school located in Peabody, Massachusetts. In 1893, the Sisters of Notre Dame opened Saint John the Baptist School to educate the children of the parish. Today Saint John School continues to provide a quality, Catholic education for students from Peabody and several other North Shore communities.",
      description2:
        "We are opening August 31 with 5 days of in-school instruction.",
      attributes: [
        "PreK-8",
        "Start Date: 8/31/2020",
        "5 Days Live Instruction",
      ],
    },
    {
      admissionLink: "https://www.sjscanton.org/admissions",
      school: "Saint John the Evangelist School",
      image: "SaintJohntheEvangelistSchoolDanvers",
      city: "Canton",
      gender: "Coed",
      address1: "696 Washington Street",
      address2: "Canton, MA 02021",
      phone: "(781) 828-2130",
      phoneLink: "781-828-2130",
      website: "https://www.sjscanton.org/",
      maps: "",
      description1:
        "Saint John the Evangelist School is a Pre-K (age 3) through Grade 8 Catholic school located in Canton, Massachusetts. Saint John School was established in 1883 and has educated thousands of saints and scholars. These graduates have gone on to excellent high schools, colleges, and careers and make a daily impact on society.",
      description2:
        "We are opening September 2 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/2/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.saintjohnschool.net/admissions/",
      school: "Saint John the Evangelist School",
      image: "SaintJohntheEvangelistSchoolWellesley",
      city: "Wellesley Hills",
      gender: "Coed",
      address1: "9 Ledyard Street",
      address2: "Wellesley Hills, MA 02481",
      phone: "(781) 235-0300",
      phoneLink: "781-235-0300",
      website: "https://www.saintjohnschool.net/",
      maps: "",
      description1:
        "Saint John the Evangelist School is a Pre-K (2.9) through Grade 6 Catholic elementary school located in Wellesley, Massachusetts. For more than 50 years, Saint John School has built compassionate global citizens through a unique commitment to educating the whole child. In particular we strive to develop academic excellence through a rigorous curriculum that empowers students with 21st- century skills; faith development by fostering joy, respect, and kindness through meaningful values-based education; and community through service projects and special events, which unite students, faculty, parents, alumni, and community partners alike.",
      description2:
        "We are opening September 1 with 5 days of in-school instruction.",
      attributes: ["PreK-6", "Start Date: 9/1/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.stjohnsprep.org/page.cfm?p=8231",
      school: "St. John's Preparatory School",
      image: "StJohnsPrep",
      city: "Danvers",
      gender: "Boys",
      address1: "72 Spring Street",
      address2: "Danvers, MA 01923",
      phone: "(978) 774-1050",
      phoneLink: "978-774-1050",
      website: "https://www.stjohnsprep.org",
      maps:
        "https://www.google.com/maps/place/St.+John's+Preparatory+School/@42.5826352,-70.9548829,17z/data=!3m1!4b1!4m5!3m4!1s0x89e3110b6ba6b53f:0x14df8715a72ac50a!8m2!3d42.5826313!4d-70.9526942",
      description1:
        "Grounded in the traditions of Catholic education, and inspired by the vision and values of the Xaverian Brothers, St. John’s Prep in Danvers, Massachusetts, strives to open the doors to endless possibilities for students. Teachers foster intellectual and spiritual growth, inspire a commitment to servant leadership, and nurture the gifts and talents of all of our students. This growth, commitment, and nurturing happen with sixth graders all the way to the college-bound seniors.",
      description2: "",
      attributes: ["6-12"],
    },
    {
      admissionLink: "https://sjsmedford.com/tuition-financial-aid/",
      school: "Saint Joseph School",
      image: "SaintJosephElementarySchoolMedford",
      city: "Medford",
      gender: "Coed",
      address1: "132 High Street",
      address2: "Medford, MA 02155",
      phone: "(781) 396-3636",
      phoneLink: "781-396-3636",
      website: "https://sjsmedford.com/",
      maps: "",
      description1:
        "Saint Joseph School is a Pre-K through Grade 8 Catholic elementary school located in Medford, Massachusetts. Saint Joseph School was established in 1929 to serve the children of the Saint Joseph Parish and educate them on the teachings of Jesus Christ.",
      description2:
        "We are opening September 3 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/3/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.saintjoes.com/admissions/",
      school: "Saint Joseph School",
      image: "StJosephNeedham",
      city: "Needham",
      gender: "Coed",
      address1: "90 Pickering Street",
      address2: "Needham, MA 02492",
      phone: "(781) 444-4459",
      phoneLink: "781-444-4459",
      website: "https://www.saintjoes.com/",
      maps: "",
      description1:
        "Saint Joseph Elementary School is a Pre-K (age 3) through Grade 8 Catholic elementary school located in Needham, Massachusetts. Saint Joseph Elementary has a rich history of educating children since the Sisters of Charity in Halifax came to the parish in 1939. At Saint Joseph Elementary School, the faculty and staff believe that it is essential to provide students with an education rich in Catholic principles, a challenging curriculum, prayerful and faith-filled liturgies, and the opportunity to serve their school and global community using the gifts and talents God has given each of us. The pillars upon which they build their educational environment are grounded in their mission statement: seek, strive, share, and serve. Through these four pillars, the whole school community (students, parents, teachers, and staff) acquires a foundation in faith, values, knowledge and skills needed to learn and work together daily. Saint Joseph Elementary School prepares students through a commitment to high academic standards, the importance of moral responsibility, respect for all, as well as community involvement, and growth based on Catholic beliefs. Through their diverse programs and specialty classes they teach to the whole child.",
      description2:
        "We are opening September 9 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/9/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.stjosephschoolwakefield.org/domain/25",
      school: "Saint Joseph School",
      image: "SaintJosephElementarySchoolWakefield",
      city: "Wakefield",
      gender: "Coed",
      address1: "15 Gould Street",
      address2: "Wakefield, MA 01880",
      phone: "(781) 245-2081",
      phoneLink: "781-245-2081",
      website: "https://www.stjosephschoolwakefield.org",
      maps: "",
      description1:
        "Saint Joseph School is a Pre-K through grade 8 Catholic elementary school located in Wakefield, Massachusetts. As a Catholic school, Saint Joseph seeks to propagate the message of Jesus Christ and an approach to life rooted firmly in Christian values. Since 1924, Saint Joseph has been providing a quality education, meeting the academic demands of the 21st Century, and guiding students to success in their scholarly endeavors.",
      description2:
        "We are opening September 8 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/8/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.saintjosephprep.org/admissions/intro",
      school: "Saint Joseph Preparatory High School",
      videoUrl: "296089617",
      image: "StJoseph",
      city: "Boston",
      gender: "Coed",
      address1: "617 Cambridge Street",
      address2: "Boston, MA 02134",
      phone: "(617) 254-8383",
      phoneLink: "617-254-8383",
      website: "https://www.saintjosephprep.org/",
      maps:
        "https://www.google.com/maps/place/Saint+Joseph+Preparatory+High+School/@42.3523323,-71.1449979,17z/data=!4m13!1m7!3m6!1s0x89e379cb62ffffff:0xbc502c824d4891c5!2s617+Cambridge+St,+Boston,+MA+02134!3b1!8m2!3d42.3523323!4d-71.1428092!3m4!1s0x89e379cb6c277bf5:0xa2196fbf65df19b3!8m2!3d42.3523323!4d-71.1428092",
      description1:
        "Saint Joseph Preparatory High School is a private Catholic high school serving Grades 9 through 12 in Brighton, Massachusetts. Built on academic excellence, authentic community, meaningful engagement, and dynamic innovation, Saint Joseph Preparatory High School is a vibrant school community providing a student-centered educational experience.",
      description2:
        "We are opening September 10 with a hybrid model of in-school and online instruction",
      attributes: ["9-12", "Start Date: 9/10/2020", "Hybrid Model"],
    },
    {
      admissionLink: "https://www.stmaryslynn.com/admissions",
      school: "Saint Mary's High School",
      image: "StMary",
      city: "Lynn",
      gender: "Coed",
      address1: "35 Tremont Street",
      address2: "Lynn, MA 01902",
      phone: "(781) 595-7885",
      phoneLink: "781-595-7885",
      website: "https://www.stmaryslynn.com/",
      maps: "",
      description1:
        "Saint Mary’s High School, located in Lynn, Massachusetts, is a college-preparatory school serving students in Grades 6 through 12. Saint Mary’s offers rigorous academic and co-curricular programs that encourage young men and women to reach their spiritual, intellectual, moral, physical and creative potential. Their four pillars of Catholicity, Excellence, Integrity and Respect are the foundations of the school.",
      description2:
        "We are opening August 31 with 5 days of in-school instruction.",
      attributes: ["6-12", "Start Date: 8/31/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://stmaryschooldanvers.org/admissions/",
      school: "Saint Mary of the Annunciation School",
      image: "SaintMaryoftheAnnunciationSchoolDanvers",
      city: "Danvers",
      gender: "Coed",
      address1: "14 Otis Street",
      address2: "Danvers, MA 01923",
      phone: "(978) 774-0307",
      phoneLink: "978-774-0307",
      website: "https://www.stmaryschooldanvers.org",
      maps: "",
      description1:
        "Combining the best of classical education methods with modern teaching techniques, Saint Mary of the Annunciation School provides a rigorous academic program for students Prek 3 - grade 8. Located in Danvers, Massachusetts, Saint Mary’s has collaborated with Bishop Fenwick High School on a strategic partnership in order for students to have a positive and continuous Catholic school educational experience through 12th grade. With a student/teacher ratio of 11:1, an experienced, dedicated faculty blend experiential learning methods, leadership programs, and structured routines so that students develop ownership and a love for learning.",
      description2:
        "We are opening September 8 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/8/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.stmaryschoolmelrose.org/admissions",
      school: "Saint Mary of the Annunciation School",
      image: "SaintMaryoftheAnnunciationSchoolMelrose",
      city: "Melrose",
      gender: "Coed",
      address1: "4 Myrtle Street",
      address2: "Melrose, MA 02176",
      phone: "(781) 665-5037",
      phoneLink: "781-665-5037",
      website: "https://www.stmaryschoolmelrose.org/",
      maps: "",
      description1:
        "Saint Mary of the Annunciation School in Melrose, Massachusetts, is a Pre-K through grade 8 Catholic elementary school in the Archdiocese of Boston. When the school first opened its doors in 1909, it was staffed by the Sisters of the Holy Child Jesus. For more than a century, Saint Mary’s School has provided its school community with faith formation, academic excellence and a rich history of tradition.",
      description2:
        "We are opening September 2 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/2/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://stmarys-brookline.org/admissions/",
      school: "Saint Mary of the Assumption Elementary School",
      image: "SaintMaryoftheAnnunciationSchool",
      city: "Brookline",
      gender: "Coed",
      address1: "67 Harvard Street",
      address2: "Brookline, MA 02445",
      phone: "(617) 566-7184",
      phoneLink: "617-566-7184",
      website: "https://www.stmarys-brookline.org",
      maps: "",
      description1:
        "Saint Mary of the Assumption is a Pre-K (age 2.9) through grade 8 Catholic elementary school located in Brookline, MA. Saint Mary’s was established as a parish school in 1899. During its early years, the school was staffed by the Sisters of Notre Dame de Namur and later by the Sisters of Saint Joseph. Saint Mary of the Assumption has over one hundred years of noble existence as an established private Catholic school.",
      description2:
        "We are opening September 9 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/9/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.smhschool.org/admissions1",
      school: "Saint Mary of the Hills School",
      image: "SaintMaryoftheHillsSchool",
      city: "Milton",
      gender: "Coed",
      address1: "250 Brook Road",
      address2: "Milton, MA 02186",
      phone: "(617) 698-2464",
      phoneLink: "617-698-2464",
      website: "https://www.smhschool.org",
      maps: "",
      description1:
        "Saint Mary of the Hills School is a Preschool through grade 8 Catholic elementary school located in Milton, MA. For many years, Saint Mary of the Hills School has offered a strong spiritual and academic foundation for students in its community and beyond.",
      description2:
        "We are opening September 1 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/1/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink:
        "https://school.saint-michael.com/application-for-admission.html",
      school: "Saint Michael Elementary School",
      image: "StMichaelLowell",
      city: "Lowell",
      gender: "Coed",
      address1: "21 Sixth Street",
      address2: "Lowell, MA 01850",
      phone: "(978) 453-9511",
      phoneLink: "978-453-9511",
      website: "https://school.saint-michael.com/",
      maps: "",
      description1:
        "Saint Michael School is a Pre-K (3 & 4 year old) through Grade 8 Catholic elementary school located in Lowell, MA. Saint Michael’s was founded in 1889 by the Dominican Sisters, to educate children and instill the knowledge and appreciation of Catholic tradition.",
      description2:
        "We are opening September 1 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/1/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.saintmichael.com/admissions/",
      school: "Saint Michael School",
      image: "StMichaelNorthAndover",
      city: "North Andover",
      gender: "Coed",
      address1: "80 Maple Avenue",
      address2: "North Andover, MA 01845",
      phone: "(978) 686-1862",
      phoneLink: "978-686-1862",
      website: "https://www.saintmichael.com",
      maps: "",
      description1:
        "Saint Michael School is a Pre-K through grade 8 Catholic elementary school located in North Andover, MA. Saint Michael School promotes gospel values through prayer, religious instruction and community outreach, striving to carry on the spirit of faith and love initiated by the Sisters of Charity of Halifax. The Saint Michael staff is committed to offering a quality education in a safe, caring and friendly atmosphere. In addition to the strong academic foundation your child will receive at Saint Michael’s, he or she will develop friendships, leadership skills, responsibility, a Catholic identity, and self-discipline.",
      description2:
        "We are opening September 2 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/2/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.methuencatholic.org/admissions",
      school: "Saint Monica School",
      image: "SaintMonicaSchool",
      city: "Methuen",
      gender: "Coed",
      address1: "212 Lawrence Street",
      address2: "Methuen, MA 01844",
      phone: "(978) 686-1801",
      phoneLink: "978-686-1801",
      website: "https://www.methuencatholic.org/school",
      maps: "",
      description1:
        "Founded in 1958 by the Sisters of Notre Dame, Saint Monica School has been serving the Methuen, Massachusetts, community for over six decades. Today, Saint Monica School offers a strong, Catholic education for preschoolers through grade eight students throughout the Merrimack Valley and Southern New Hampshire. Saint Monica school is a home away from home to its faculty and scholars, demonstrating the rich, diverse, and tightly woven community that it is.     ",
      description2:
        "We are opening September 1 with 5 days of in-school instruction.",
      attributes: ["K-8", "Start Date: 9/1/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://saintpatricklowell.org/financial-aid-%2F-cost",
      school: "Saint Patrick School and Educational Center",
      image: "SaintPatrickSchoolLowell",
      city: "Lowell",
      gender: "Coed",
      address1: "St. Patrick School 311 Adams Street",
      address2: "Lowell, MA 01854",
      phone: "(978) 458-4232",
      phoneLink: "978-458-4232",
      website: "http://www.saintpatricklowell.org",
      maps: "",
      description1:
        "Saint Patrick School is a Pre-K through Grade 8 Catholic elementary school, sponsored by the Sisters of Notre Dame de Namur, and located in Lowell, Massachusetts. Saint Patrick School and Educational Center is a family of students, teachers and parents who share belief in God and form a community of welcome and respect for all.  The school is committed to excellence in education. Saint Patrick believes all children are learners and recognizes that they have different styles of learning. Saint Patrick faculty make conscious efforts in instruction and evaluation to recognize and respond to these differences.",
      description2: "",
      attributes: ["PreK-8"],
    },
    {
      admissionLink: "http://stpatrickschoolstoneham.org/admission/",
      school: "Saint Patrick School",
      image: "StPatrickStoneham",
      city: "Stoneham",
      gender: "Coed",
      address1: "20 Pleasant Street",
      address2: "Stoneham, MA 02180",
      phone: "(781) 438-2593",
      phoneLink: "781-438-2593",
      website: "http://www.stpatrickschoolstoneham.org",
      maps: "",
      description1:
        "Saint Patrick School is a Pre-K through Grade 8 Catholic elementary school located in Stoneham, Massachusetts. Saint Patrick School is the place where tradition meets innovation. Saint Patrick School is committed to the social growth of its students. Families value Saint Patrick’s safe environment that educates students while teaching them devout faith every day they are there.",
      description2:
        "We are opening September 8 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/8/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "http://www.stpaulschoolhingham.com/admissions.html",
      school: "Saint Paul School",
      image: "SaintPaulSchool",
      city: "Hingham",
      gender: "Coed",
      address1: "18 Fearing Road",
      address2: "Hingham, MA 02043",
      phone: "(781) 749-2407",
      phoneLink: "781-749-2407",
      website: "http://www.stpaulschoolhingham.com",
      maps: "",
      description1:
        "Saint Paul is a Pre K through grade 8 Catholic elementary school located in Hingham, Massachusetts. Saint Paul School is a community in which love of God, neighbor and self are foremost. Saint Paul’s provide a challenging curriculum promoting academic excellence infused with Catholic traditions and values.",
      description2:
        "We are opening September 1 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/1/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.saintpaulschoirschool.us/admissions",
      school: "Saint Paul's Choir School",
      image: "SaintPaulsChoirSchool",
      city: "Cambridge",
      gender: "Boys",
      address1: "29 Mount Auburn Street",
      address2: "Cambridge, MA 02138",
      phone: "(617) 868-8658",
      phoneLink: "617-868-8658",
      website: "https://www.saintpaulschoirschool.us/",
      maps: "",
      description1:
        "Saint Paul’s Choir School (SPCS) provides boys in grades 3-8 an incomparable foundation for a life of achievement, virtue, and service to others. Founded in 1963, SPCS embraces the great cathedral school tradition, uniting a classical academic and musical curriculum with the Catholic moral tradition. Within this community of camaraderie and high expectations, students build the habits of mind and heart to rise to all of life’s demands and thrive in a world characterized by constant change. This extraordinary educational experience takes place in the heart of Harvard Square, one of the world’s great centers of learning, ideas, and diversity.",
      description2:
        "We are opening September 2 with 5 days of in-school instruction.",
      attributes: ["3-8", "Start Date: 9/2/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://saint-peter-school.org/admissions",
      school: "Saint Peter School",
      image: "SaintPeterSchool",
      city: "Cambridge",
      gender: "Coed",
      address1: "96 Concord Avenue",
      address2: "Cambridge, MA 02138",
      phone: "(617) 547-0101",
      phoneLink: "617-547-0101",
      website: "https://www.saint-peter-school.org",
      maps: "",
      description1:
        "Saint Peter School serves girls and boys in PreK (Pre-K) through grade 8 and offers a rigorous academic program to a diverse student body, which includes many international students. Graduates of Saint Peter School go on to excel at many local and international high schools.",
      description2:
        "We are opening September 8 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/8/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://sp-ma.client.renweb.com/oa/?memberid=2699",
      school: "Saint Pius V Elementary School",
      image: "SaintPiusVElementarySchool",
      city: "Lynn",
      gender: "Coed",
      address1: "28 Bowler Street",
      address2: "Lynn, MA 01904",
      phone: "(781) 593-8292",
      phoneLink: "781-593-8292",
      website: "http://www.stpiusvschool.org",
      maps: "",
      description1:
        "Saint Pius V School is an Age 3 through grade 8 Catholic school located in Lynn, Massachusetts. For over 70 years, Saint Pius V School has welcomed students to a place of Catholic values, diversity, and strong curriculum, always seeking to meet the needs of every student.",
      description2:
        "We are opening September 2 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/2/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://straphaelparishschool.org/admissions/",
      school: "Saint Raphael Parish School",
      image: "SaintRaphaelParishSchool",
      city: "Medford",
      gender: "Coed",
      address1: "516 High Street",
      address2: "Medford, MA 02155",
      phone: "(781) 483-3373",
      phoneLink: "781-483-3373",
      website: "https://www.straphaelparishschool.org",
      maps: "",
      description1:
        "Saint Raphael Parish School is an Early Childhood through Grade 8 Catholic elementary school located in Medford, Massachusetts. Saint Raphael is part of a vibrant Catholic parish school community, where each student is nurtured and valued as a child of God. Children are inspired to grow spiritually, intellectually, morally and socially as they build the knowledge, character and faith to become leaders within and beyond our community.",
      description2:
        "We are opening September 16 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/16/20", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.stsebs.org/admissions/why-st-sebastians",
      school: "Saint Sebastian's School",
      image: "StSebas",
      city: "Needham",
      gender: "Boys",
      address1: "1191 Greendale Avenue",
      address2: "Needham, MA 02492",
      phone: "(781) 449-5200",
      phoneLink: "781-449-5200",
      website: "https://www.stsebs.org/",
      maps:
        "https://www.google.com/maps/place/St.+Sebastian's+School/@42.2687702,-71.2089775,18.07z/data=!4m12!1m6!3m5!1s0x89e381ce2f92620b:0x8a00fe5324fe44b7!2sSt.+Sebastian's+School!8m2!3d42.26893!4d-71.207237!3m4!1s0x89e381ce2f92620b:0x8a00fe5324fe44b7!8m2!3d42.26893!4d-71.207237",
      description1:
        "Saint Sebastian’s School  is a Catholic independent day school located in Needham, Massachusetts. Saint Sebastian’s embraces Gospel values in a nurturing community, inspiring intellectual excellence, and seeking to engage young men in the pursuit of truth through faith and reason. Founded in 1941, the all-boys school serves young men in Grades 7 through 12 in an effort to actively develop the body, mind and soul of its students, with a strong emphasis on cultivating and deepening each student’s spiritual life.",
      description2:
        "We are opening September 1 with 5 days of in-school instruction.",
      attributes: ["7-12", "Start Date: 9/1/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.sttheresaschoolsomerville.com/admissions",
      school: "Saint Theresa Catholic School",
      image: "SaintTheresaCatholicSomerville",
      city: "Somerville",
      gender: "Coed",
      address1: "192 Summer Street",
      address2: "Somerville, MA 02143",
      phone: "(617) 666-9116",
      phoneLink: "617-666-9116",
      website: "https://www.sttheresaschoolsomerville.com/",
      maps: "",
      description1:
        "Saint Theresa Catholic School is a Pre-K through Grade 8 Catholic school located in Somerville, Massachusetts. For over 90 years the school has provided students with the same standards of excellence through a rigorous academic life and a rich faith life. Saint Theresa's student population enjoys a very diverse mix of students, thereby promoting acceptance and community building in a conducive learning environment.",
      description2:
        "We are opening September 1 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/1/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.sttheresaschoolboston.com/admissions-1",
      school: "Saint Theresa of Avila School",
      image: "SaintTheresaofAvilaWestRoxbury",
      city: "West Roxbury",
      city2: "Boston",
      gender: "Coed",
      address1: "40 St. Theresa Avenue",
      address2: "West Roxbury, MA 02132",
      phone: "(617) 323-1050",
      phoneLink: "617-323-1050",
      website: "https://www.sttheresaschoolboston.com",
      maps: "",
      description1:
        "Saint Theresa of Avila School is rooted in the Catholic tradition and serves students of diverse populations. As a member of the system of Catholic Schools in the Archdiocese of Boston, Saint Theresa School fosters the practice of tolerance, social justice and charity for all within the framework of traditional Catholic values. To further these practices, the school community pledges to preserve a peaceful atmosphere. This leads to a caring and respectful school community that both promotes and protects the dignity and self-worth of each child. The primary goal for students is to strive for both academic excellence and positive social skills within this faith filled environment. Saint Theresa School is committed to teaching students through various pedagogical methods and strategies. Through these challenge students develop a thirst for knowledge, develop critical thinking skills and acquire an inquisitive nature for future studies and endeavors.",
      description2:
        "We are opening September 8 with 5 days of in-school instruction.",
      attributes: ["PreK-6", "Start Date: 9/8/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.sjdarc.org/admissions/",
      school: "Ste Jeanne d'Arc School",
      image: "SteJeannedArcSchool",
      city: "Lowell",
      gender: "Coed",
      address1: "68 Dracut Street",
      address2: "Lowell, MA 01854",
      phone: "(978) 453-4114",
      phoneLink: "978-453-4114",
      website: "https://www.sjdarc.org",
      maps: "",
      description1:
        "Ste Jeanne d’Arc School is a Pre-K3 through Grade 8 Catholic elementary school located in Lowell, Massachusetts. Founded in 1910 by the Oblates of Mary Immaculate, it is affiliated with the Saint Rita Parish community and staffed by the Sisters of Charity of Ottawa.",
      description2: "We will have 5 days of in-school instruction.",
      attributes: ["PreK-8"],
    },
    {
      admissionLink: "https://www.saintsacademy.org/domain/28",
      school: "The Saints Academy",
      image: "TheSaintsAcademy",
      city: "Beverly",
      gender: "Coed",
      address1: "111 New Balch Street",
      address2: "Beverly, MA 01915",
      phone: "(978) 922-0048",
      phoneLink: "978-922-0048",
      website: "https://www.saintsacademy.org/",
      maps: "",
      description1:
        "The Saints Academy is a Pre-K through Grade 8 Catholic elementary school located in Beverly, Massachusetts. The Saints Academy is a product of the unification of two Catholic school communities in Beverly - St. Mary Star of the Sea School and St. John the Evangelist School in order to bring Catholic education in Beverly to the next generation of children and families on the North Shore of Massachusetts.",
      description2:
        "We are opening September 1 with 5 days of in-school instruction.",
      attributes: ["PreK-8", "Start Date: 9/1/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://tcabrockton.org/admissions/",
      school: "Trinity Catholic Academy",
      image: "TrinityCatholicAcademy",
      city: "Brockton",
      gender: "Coed",
      address1: "37 Erie Avenue",
      address2: "Brockton, MA 02302",
      phone: "(508) 583-6225",
      phoneLink: "508-583-6225",
      website: "https://www.tcabrockton.org/",
      maps: "",
      description1:
        '"Trinity Catholic Academy (TCA) is a Pre-K through Grade 8 Catholic elementary school located in Brockton, Massachusetts, with a lower Campus on North Main Street and an upper campus on Erie Avenue. Trinity Catholic Academy was founded in 2007 and has a partnership with Stonehill College to enhance curriculum and provide professional teacher development. \n' +
        'As the only Catholic elementary and middle school in Brockton, Trinity Catholic Academy provides a highly structured, safe environment combined with an excellent academic program, emphasizing math and language arts."',
      description2:
        "We are opening September 2 with 5 days of in-school instruction.",
      attributes: ["K-8", "Start Date: 9/2/2020", "5 Days Live Instruction"],
    },
    {
      admissionLink: "https://www.ursulineacademy.net/admissions",
      school: "Ursuline Academy",
      image: "UrsulineAcademy",
      city: "Dedham",
      gender: "Girls",
      address1: "85 Lowder Street",
      address2: "Dedham, MA 02026",
      phone: "(781) 326-6161",
      phoneLink: "781-326-6161",
      website: "https://www.ursulineacademy.net",
      maps:
        "https://www.google.com/maps/place/Ursuline+Academy/@42.245394,-71.1863965,17z/data=!3m1!4b1!4m5!3m4!1s0x89e37f8e9e323907:0x38e4a6d8a9930f3e!8m2!3d42.24539!4d-71.1842077",
      description1:
        "Ursuline Academy, an independent Catholic school founded in Boston in 1946, inspires students “to grow in faith, explore their academic potential, lead with confidence, and help those in need.”  In a tradition combining the best of all-girls and Catholic schools, Ursuline students flourish in an environment that encourages them to become women who make a difference: women who build lives of purpose, discovering who they want to be as individuals while discerning who they are meant to be as global citizens.",
      description2:
        "We are opening September 8 with a hybrid model of in-school and online instruction",
      attributes: ["7-12", "Start Date: 9/8/2020", "Hybrid Model"],
    },
    {
      admissionLink: "https://www.xbhs.com/admissions",
      school: "Xaverian Brothers High School",
      image: "XaverianBrothers",
      city: "Westwood",
      gender: "Boys",
      address1: "800 Clapboardtree Street",
      address2: "Westwood, MA 02090",
      phone: "(781) 326-6392",
      phoneLink: "781-326-6392",
      website: "https://www.XBHS.com",
      maps:
        "https://www.google.com/maps/place/Xaverian+Brothers+High+School/@42.2148918,-71.1982086,17z/data=!3m1!4b1!4m5!3m4!1s0x89e47ffcc2bf1f79:0x99dfd7607ead2b63!8m2!3d42.2148878!4d-71.1960199",
      description1:
        "Xaverian Brothers High School is a Catholic, college-preparatory school for boys in grades 7-12, located in Westwood, Massachusetts, established in 1963, and sponsored by the Xaverian Brothers. The campus boasts 36 acres serving a community of students from over 90 cities and towns. At Xaverian, young men discover the true meaning of strength in an inclusive community where the dignity of each person is respected so that all can thrive. Students are empowered to achieve beyond their expectations and share their gifts with a world in need.",
      description2:
        "We are opening September 11 with a hybrid model of in-school and online instruction.",
      attributes: ["7-12", "Start Date: 9/11/2020", "Hybrid Model"],
    },
  ],
  footer: {
    social: {
      facebook: "https://www.facebook.com/CSOBoston/",
      twitter: "https://twitter.com/CSOboston",
      instagram: "https://www.instagram.com/csoboston/",
      youtube: "https://www.youtube.com/user/bostoncatholic",
      vimeo: "http://www.vimeo.com/bostoncatholic",
      email:
        "http://www.bostoncatholic.org/About-The-Archdiocese/Contact-Us.aspx?id=262",
    },
    content: {
      title: "Catholic Schools of Boston",
      phone: "617-779-3601",
      email: "email@emailaddress.com",
      allContent: "All content © Archdiocese of Boston",
      terms: "Terms of Use",
      privacy: "Privacy Policy",
    },
    conditions: {
      terms: "http://www.bostoncatholic.org/Content.aspx?id=5068",
      policy: "http://www.bostoncatholic.org/Content.aspx?id=5066",
    },
  },
};

export default data;



// WEBPACK FOOTER //
// ./src/data/data.js